<script context="module">
  export const selector = ".hol-schedule-locator";
</script>


<script lang="ts">
  import {onDestroy, onMount} from "svelte";
  import LocationTypeahead from "../LocationTypeahead/LocationTypeahead.svelte";
  import {userStore} from "../stores/UserStore";
  import {
    CreateHolidayServiceAreasWrapper,
    HolidayScheduleByStateRow,
  } from "./HolidayScheduleLocator";
  import {SortSheduleByDates} from "./HolidayScheduleLocator";
  import Tooltip from "../Tooltip/Tooltip.svelte";
  import type {SearchAddressResult} from "../../../typings/Location";

  export let noResultsLabel: string = "";
  export let resultsLabel: string = "";
  export let searchTitle: string = "";
  export let serviceData: string = "";
  export let typeaheadPlaceholder: string = "";
  export let tooltipText: string = "";
  export let tooltipLink: string = "";


  export let apiGetSearchAddress: string = "";
  export let apiGetSearchAddressReverse: string = "";


  const {userAddress} = userStore;
  let serviceDataListWrapper = CreateHolidayServiceAreasWrapper(serviceData);
  let displayList = [];
  let isInServiceArea = false;
  let isInputClear: boolean;
  let unsubscribe;
  let dropdownOptions = ["Business Address", "Residential Address"];
  let selectedDropdownOption = "";
  const excludedStates = ["ME", "NH"];

  onMount(async () => {
    unsubscribe = userAddress.subscribe((addressWrapper) => {
      if (!addressWrapper) return;


      isInServiceArea = serviceDataListWrapper.ServiceProviderInState.includes(
        addressWrapper.address.countrySubdivision
      );

      if (isInServiceArea) {
        // re-create display list whenever user address store is updated
        displayList = serviceDataListWrapper.Holidays.map((item) => {
          return new HolidayScheduleByStateRow(item, addressWrapper.address.countrySubdivision);
        });
      }

      displayList = SortSheduleByDates(displayList);
    });
  });

  function onClear() {
    const nationalScheduleComponents = document.querySelectorAll(".national-schedule-component");
    const stateScheduleComponents = document.querySelectorAll(".state-holiday-component");

    for (var i = 0; i < nationalScheduleComponents.length; i++) {
      nationalScheduleComponents[i].style.display = "block";
    }

    for (var i = 0; i < stateScheduleComponents.length; i++) {
      stateScheduleComponents[i].style.display = "none";
    }

    selectedDropdownOption = "";
  }

  function selectDropdownOption(option) {
    let stateHolidayTables = document.querySelectorAll(".state-holiday-table");
    if (option == "Business Address") {
      stateHolidayTables.forEach((table) => {
        table.classList.add("business-address-table");
        table.classList.remove("residential-address-table");
      });
    } else {
      stateHolidayTables.forEach((table) => {
        table.classList.remove("business-address-table");
        table.classList.add("residential-address-table");
      });
    }
    selectedDropdownOption = option;
  }

  function dispatchGTMScheduleLookupEvent(address: SearchAddressResult, addressType) {
    const scheduleLookupEvent = new CustomEvent('scheduleLookup', {
      detail: {
        ...address,
        addressType,
      }
    });

    document.dispatchEvent(scheduleLookupEvent);
  }

  function onSubmitWithDropdown() {
    const nationalScheduleComponents = document.querySelectorAll<HTMLElement>(".national-schedule-component");
    const stateScheduleComponents = document.querySelectorAll<HTMLElement>(".state-holiday-component");

    if (excludedStates.includes($userAddress.address.countrySubdivision) && selectedDropdownOption == "Residential Address") {
      isInServiceArea = false;
    } else {
      isInServiceArea = serviceDataListWrapper.ServiceProviderInState.includes(
        $userAddress.address.countrySubdivision
      );

      if (isInServiceArea) {
        // re-create display list whenever user address store is updated
        displayList = serviceDataListWrapper.Holidays.map((item) => {
          return new HolidayScheduleByStateRow(item, $userAddress.address.countrySubdivision);
        });

        displayList = SortSheduleByDates(displayList);
      }

      if ($userAddress) {
        dispatchGTMScheduleLookupEvent($userAddress, selectedDropdownOption);
      }
    }

    if (displayList.length && $userAddress && isInServiceArea) {
        for (let i = 0; i < nationalScheduleComponents.length; i++) {
          nationalScheduleComponents[i].style.display = "none";
        }
    } else {
        for (let i = 0; i < nationalScheduleComponents.length; i++) {
          nationalScheduleComponents[i].style.display = "block";
        }
    }

    for (let i = 0; i < stateScheduleComponents.length; i++) {
      stateScheduleComponents[i].style.display = "block";
    }
  }

  onDestroy(() => {
    unsubscribe();
  });
</script>

<div>
  <div class="locator__search--wrapper">
    <div class="hol-schedule-locator__search container">
      <p>{searchTitle}</p>
      <LocationTypeahead onClear={onClear}
         selectedDropdownOption={selectedDropdownOption}
         onSelectDropdownOption={selectDropdownOption}
         dropdownOptions={dropdownOptions}
         onSubmitWithDropdown={onSubmitWithDropdown}
         bind:isInputClear={isInputClear}
         placeholder={typeaheadPlaceholder}
         apiGetSearchAddress={apiGetSearchAddress}
         apiGetSearchAddressReverse={apiGetSearchAddressReverse}
         invalidAddressMessage={"We could not find this address"}
      />
    </div>
  </div>
  <div class="hol-schedule component state-holiday-component">
    <div class="hol-schedule-common-section">
      <div class="container">
        <div class="hol-schedule-locator__list">
          {#if displayList.length && $userAddress && isInServiceArea}
            <div class="top-table-caption">
              <div class="caption-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
                  <g transform="translate(-7364 1644)">
                    <path d="M17,1A16,16,0,0,0,5.686,28.314,16,16,0,0,0,28.314,5.686,15.9,15.9,0,0,0,17,1m0-1A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z"
                          transform="translate(7364 -1644)" fill="#c10016"/>
                    <g transform="translate(7378 -1638)">
                      <path d="M1,1V13H5V1H1M1,0H5A1,1,0,0,1,6,1V13a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z" transform="translate(0 8)"
                            fill="#c10016"/>
                      <path d="M3,1A2,2,0,1,0,5,3,2,2,0,0,0,3,1M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" fill="#c10016"/>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="caption-text-container">
                {@html resultsLabel}
              </div>
            </div>
            <div class="hol-schedule-common-top">
              <p>These commonly observed holidays may affect your service during the year.</p>
              <div class="hol-schedule-sort btn-group" role="group" aria-label="sort holiday by upcoming or all">
                <button class="btn btn-normal btn-primary hol-schedule-sort__btn hol-schedule-sort__btn--upcoming">Upcoming</button>
                <button class="btn btn-normal btn-outline-primary hol-schedule-sort__btn hol-schedule-sort__btn--all">All</button>
              </div>
            </div>
            <table class="table table-striped--js table--win-red-light upcoming-table state-holiday-table">
              <thead class="table-primary text-uppercase">
              <tr>
                <th scope="col" class="thead__holiday">Holiday</th>
                {#if tooltipText || tooltipLink}
                  <th scope="col" class="thead__estimated-delay">
                    Estimated Delay
                    <svg
                      id="scheduleUpdate"
                      style="cursor: pointer"
                      width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <g fill-rule="nonzero" fill="none">
                        <path d="M8 .75c2.006 0 3.818.81 5.13 2.12A7.227 7.227 0 0 1 15.25 8a7.232 7.232 0 0 1-2.126 5.126A7.223 7.223 0 0 1 8 15.25a7.232 7.232 0 0 1-5.126-2.126A7.223 7.223 0 0 1 .75 8c0-1.998.812-3.812 2.126-5.126A7.223 7.223 0 0 1 8 .75z" stroke="#FFF" stroke-width="1.5"></path>
                        <path d="M8 .75c2.006 0 3.818.81 5.13 2.12A7.227 7.227 0 0 1 15.25 8a7.232 7.232 0 0 1-2.126 5.126A7.223 7.223 0 0 1 8 15.25a7.232 7.232 0 0 1-5.126-2.126A7.223 7.223 0 0 1 .75 8c0-1.998.812-3.812 2.126-5.126A7.223 7.223 0 0 1 8 .75z" stroke="#FFF" stroke-width="1.5"></path>
                        <path d="M8.74 4.3c.149.186.26.41.26.71 0 .261-.111.523-.296.71-.37.373-1.037.373-1.408 0A1.026 1.026 0 0 1 7 5.01c0-.3.111-.524.296-.71.186-.225.445-.3.704-.3.296 0 .556.112.74.3zM9 7.827v3.347c0 .459-.444.826-1 .826s-1-.367-1-.826V7.827C7 7.367 7.444 7 8 7s1 .367 1 .827z" fill="#FFF"></path>
                      </g>
                    </svg>
                    <Tooltip placement="top" target="scheduleUpdate">
                      {#if tooltipText}
                        <div>{tooltipText}</div>
                      {/if}
                      {#if tooltipLink}
                        <a href='${tooltipLink}'>Link</a>
                      {/if}
                    </Tooltip>
                  </th>
                {:else}
                  <th scope="col" class="thead__estimated-delay">Estimated Delay</th>
                {/if}
                <th scope="col" class="thead__pickup-adjustment">Pickup Adjustment</th>
              </tr>
              </thead>
              <tbody>
              {#each displayList as result}
                <tr class="tall"
                    class:upcoming-tr={result.upcoming}
                    class:business-address-tr={result.customerType.includes('Business')}
                    class:residential-address-tr={result.customerType.includes('Residential')}
                >
                  <th scope="row">
                    <div class="holiday-name-label">{result.holidayName}</div>
                    <div>
                      <span class="days-to-go-label">{result.daysToGo}</span>
                      <span class="date-label">{result.holidayDateFormatted}</span>
                    </div>
                  </th>
                  {#if result.numberofDaysDelay == 0}
                    <td class="estimated-delay no-delay">
                      <span>No delay</span>
                      <hr/>
                    </td>
                  {:else}
                    <td class="estimated-delay">
                      <span>{result.numberofDaysDelay} day delay</span>
                      <hr/>
                    </td>
                  {/if}
                  {#if result.numberofDaysDelay == 0}
                    <td class="pickup-adjustment no-delay">
                      No pickup adjustment
                    </td>
                  {:else}
                    <td class="pickup-adjustment">
                      <ul class="pickup-list">
                        {#each result.nextDeliveryTable as days}
                          <li class="pickup-item">
                            <span>{days[0]}</span>
                            pickup
                            <img src="/images/portal-icons/atom-icon-ui-dropdown-down.svg" alt="dropdown icon"/>
                            <img src="/images/portal-icons/atom-icon-ui-dropdown-down.svg" alt="dropdown icon"/>
                            <span>{days[1]}</span>
                          </li>
                        {/each}
                      </ul>
                      {#if result.customMessage !== ''}
                        <div class="no-delay">{result.customMessage}</div>
                      {/if}
                    </td>
                  {/if}
                </tr>
              {/each}
              </tbody>
            </table>
          {:else if ((!isInServiceArea && $userAddress != null) && !isInputClear)}
          <p class="hol-schedule-locator__out-of-area">{@html serviceDataListWrapper.NoServiceMessage}</p>
          {:else if $userAddress && !isInputClear}
            <p class="hol-schedule-locator__no-results">{@html noResultsLabel}</p>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
